import axios, { AxiosResponse } from 'axios'

import { formatDate } from '@/helpers/date'
import { DateFormat } from '@/types'

export const getPreferencesForMe = (startDate: Date, endDate: Date): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/me/prefer-to-work-time-slots`, {
        params: {
            startDate: formatDate(startDate, DateFormat.apiDateTime),
            endDate: formatDate(endDate, DateFormat.apiDateTime),
            orderByStart: JSON.stringify({ start: 'ASC' }),
        },
    },
)

export const getPreference = (id: string): Promise<AxiosResponse> => axios.get(`${process.env.REACT_APP_API_URL}/me/prefer-to-work-time-slots/${id}`)

export const postPlanningPreference = (startDate: string, endDate: string, reason: string, userId?: string): Promise<AxiosResponse> => {
    const body = {
        type: 'preferToWorkTimeSlot',
        attributes: {
            start: startDate,
            end: endDate,
            comment: reason,
        },
        relationships: {
            user: {
                data: {
                    type: 'users',
                    id: userId,
                },
            },
        },
    }

    return axios.post(
        `${process.env.REACT_APP_API_URL}/me/prefer-to-work-time-slots`,
        { data: body },
    )
}

export const delPlanningPreference = (id: string): Promise<AxiosResponse> => axios.delete(`${process.env.REACT_APP_API_URL}/me/prefer-to-work-time-slots/${id}`)
